export const RESOURCE_TYPE = {
  INTERNAL: `internal`,
  EXTERNAL: `external`,
}
